// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"986":"ef4a6f34ded3bce6","1408":"d24ce9dac0da9993","2430":"e8db1ccca43cf2ce","4112":"a3ede44e6a0beb25","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};